// Website API servisi
// Production: same-origin proxy (/api → kuleadmin/admin) — LiteSpeed bot korumasını bypass eder
// Development: CRA proxy (package.json) üzerinden /admin
const API_BASE_URL = process.env.NODE_ENV === 'development' ? '/admin' : '/api';

// Cache mekanizması
let cache = {
  contents: null,
  duyurular: null,
  sakinler: null,
  iletisim: null,
  lastFetch: {}
};

const CACHE_DURATION = 5 * 60 * 1000; // 5 dakika

/**
 * İçerikleri API'den çeker
 */
export const fetchContents = async () => {
  try {
    const now = Date.now();
    if (cache.contents && (now - cache.lastFetch.contents) < CACHE_DURATION) {
      return cache.contents;
    }

    const response = await fetch(`${API_BASE_URL}/contents_api.php`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.success && data.data) {
      cache.contents = data.data;
      cache.lastFetch.contents = now;
      return data.data;
    }
    throw new Error('Invalid response format');
  } catch (error) {
    console.error('Content fetch error:', error);
    return cache.contents || {};
  }
};

/**
 * Duyuruları API'den çeker
 * @param {number} page - Sayfa numarası (varsayılan: 1)
 * @param {number} perPage - Sayfa başına kayıt (varsayılan: 9)
 * @returns {Promise<Object>} { items: [], pagination: {} }
 */
export const fetchDuyurular = async (page = 1, perPage = 9) => {
  try {
    const response = await fetch(`${API_BASE_URL}/website_api.php?type=duyurular&page=${page}&per_page=${perPage}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.success && Array.isArray(data.data)) {
      return {
        items: data.data,
        pagination: data.pagination || null
      };
    }
    throw new Error('Invalid response format');
  } catch (error) {
    console.error('Duyurular fetch error:', error);
    return {
      items: cache.duyurular || [],
      pagination: null
    };
  }
};

/**
 * Sakinleri API'den çeker
 * @param {number} page - Sayfa numarası (varsayılan: 1)
 * @param {number} perPage - Sayfa başına kayıt (varsayılan: 12)
 * @returns {Promise<Object>} { items: [], pagination: {} }
 */
export const fetchSakinler = async (page = 1, perPage = 12) => {
  try {
    const response = await fetch(`${API_BASE_URL}/website_api.php?type=sakinler&page=${page}&per_page=${perPage}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.success && Array.isArray(data.data)) {
      return {
        items: data.data,
        pagination: data.pagination || null
      };
    }
    throw new Error('Invalid response format');
  } catch (error) {
    console.error('Sakinler fetch error:', error);
    return {
      items: cache.sakinler || [],
      pagination: null
    };
  }
};

/**
 * İletişim bilgilerini API'den çeker
 */
export const fetchIletisim = async () => {
  try {
    const now = Date.now();
    if (cache.iletisim && (now - cache.lastFetch.iletisim) < CACHE_DURATION) {
      return cache.iletisim;
    }

    const response = await fetch(`${API_BASE_URL}/website_api.php?type=iletisim`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.success && data.data) {
      cache.iletisim = data.data;
      cache.lastFetch.iletisim = now;
      return data.data;
    }
    throw new Error('Invalid response format');
  } catch (error) {
    console.error('İletişim fetch error:', error);
    return cache.iletisim || {};
  }
};

/**
 * Cache'i temizle
 */
export const clearCache = () => {
  cache = {
    contents: null,
    duyurular: null,
    sakinler: null,
    iletisim: null,
    lastFetch: {}
  };
};

